// extracted by mini-css-extract-plugin
export default {"label":"PopupOpenerButton_label__S6iH4","labelSelected":"PopupOpenerButton_labelSelected__OCbI3 buttonPrimary","labelEllipsis":"PopupOpenerButton_labelEllipsis__WkXuP"};